import React from 'react';

const NasLogo = () => {
  return (
    <svg
      className="c-NasLogo"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#2C2C2C"
        d="M3.135 13.733a2.53 2.53 0 010-3.564 2.498 2.498 0 013.546 0l7.092 7.129c.98.984.98 2.58 0 3.564a2.498 2.498 0 01-3.546 0l-7.092-7.129z"
      ></path>
      <path
        fill="#2C2C2C"
        d="M13.775 20.862a2.498 2.498 0 01-3.546 0 2.53 2.53 0 010-3.564l7.092-7.13a2.498 2.498 0 013.546 0c.98.985.98 2.581 0 3.565l-7.092 7.129z"
      ></path>
      <path
        fill="#FBC91B"
        d="M11.993 7.912a2.749 2.749 0 002.742-2.756A2.749 2.749 0 0011.993 2.4a2.749 2.749 0 00-2.741 2.756 2.749 2.749 0 002.741 2.756z"
      ></path>
    </svg>
  );
};

export default NasLogo;
